module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n      Software Updates! Please, login again.\n    ")]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Ok")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Update")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc73c758","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/notifications/Update.vue
// module id = 1210
// module chunks = 39